import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertSettings, AlertType } from 'src/app/alert/alert.service';
import { Address } from 'src/app/models/response-models/organisation/address';
import { Country } from 'src/app/models/response-models/organisation/country';
import { SiteCountry } from 'src/app/models/response-models/site';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { OrganisationService } from 'src/app/services/organisation.service';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css']
})
export class AddressFormComponent implements OnInit {
  @Input() address: Address;
  @Input() addressForm: UntypedFormGroup;

  countries: Country[] = [];
  loadingCountries: boolean;
  addressTypes: string[] = ["establishment","geocode"];

  countryAlert: AlertSettings;

  get siteCountry(): SiteCountry {
    return this.addressForm.get('country').value;
  }

  constructor(
    private organisationService: OrganisationService,
    private errorHandlerService: ErrorHandlerService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadCountries();
    this.changeDetectorRef.detectChanges();
  }

  loadCountries(){
    this.loadingCountries = true;
    this.organisationService.getCountries().subscribe({
      next: (response: Country[])=>{
        this.countries = response;
        this.loadingCountries = false;
      },
      error: (error:any)=>{
        this.errorHandlerService.handleError(error, (message: string)=>{
          this.countryAlert = {
            class: AlertType.ERROR,
            message: message
          }
          this.loadingCountries = false;
        });
      }
    });
  }

  getAddress(googleAddress: any){
    this.addressForm.controls.description.setValue(googleAddress.name);
    this.formatSelectedAddress(googleAddress);
  }

  formatSelectedAddress(googleAddress: any){
    for (var i = 0; i < googleAddress.address_components.length; i++) {
      let addressType = googleAddress.address_components[i].types[0];
      let addressValue = googleAddress.address_components[i].short_name;

      switch(addressType){
        case 'street_number':
          this.addressForm.controls.line1.setValue(addressValue);
          break;
        case 'route':
          this.addressForm.controls.line2.setValue(addressValue);
          break;
        case 'locality':
          this.addressForm.controls.province.setValue(addressValue);
          break;
        case 'postal_town':
          this.addressForm.controls.town.setValue(addressValue);
          break;
        case 'postal_code':
          this.addressForm.controls.postcode.setValue(addressValue);
          break;
      }
    }
  }

  setFormName(input: string){
    this.addressForm.controls.description.setValue(input);
    this.addressForm.updateValueAndValidity();
    this.addressForm.markAsDirty();
  }

  compare(t1: any, t2: any): boolean {
    return t1 && t2 ? t1.id === t2.id : t1 === t2;
  }
}
